import { render, staticRenderFns } from "./messageBox.vue?vue&type=template&id=1409c1bc&scoped=true"
import script from "./messageBox.vue?vue&type=script&lang=js"
export * from "./messageBox.vue?vue&type=script&lang=js"
import style0 from "./messageBox.vue?vue&type=style&index=0&id=1409c1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1409c1bc",
  null
  
)

export default component.exports